const downloadImage = async (imgfile) => {
  const imageUrl = imgfile.url;
  if (!imageUrl) {
    // Handle empty URL input
    console.error("Error: The image URL is empty.");
    return;
  }

  try {
    // Make the GET request to fetch the image
    const response = await fetch(imageUrl);

    if (response.ok) {
      const blob = await response.blob(); // Creates a blob from the response data
      const url = window.URL.createObjectURL(blob); // Creates a URL for the blob

      // Create an anchor element and programmatically trigger the download
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.setAttribute("download", imgfile.name); // Set the download attribute with the filename
      document.body.appendChild(anchor);
      anchor.click();

      // Cleanup: Remove the anchor and revoke the object URL
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    } else {
      console.error(
        `Error: Failed to download image. Status code: ${response.status}`
      );
    }
  } catch (error) {
    console.error(
      `Error: Failed to download the image. Exception: ${error.message}`
    );
  }
};

export default downloadImage;
